import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class ActivityManager extends ManagerBase {
	constructor () {
		super("activityManager");

		this.remoteClassName = "activity";
	}
	
	getListByProjectGuid (projectGuid, filters) {
		const rd = NousCore.api.createRequest({ filters, item: { projectGuid } });
		const requestedAction = "get-list-by-project-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const activityManager = new ActivityManager();

Shark.registerController(activityManager);

export default activityManager;

// activityManager.addMethod("create", function (activity) {
// 	Shark.requestRemoteData({
// 		context: activityManager,
// 		data: {an: "insert", d: activity.dexport(), cx: "Activity"},
// 		complete: function (response) {
// 			if (response.isSuccess) {
// 				var responseData = response.data;

// 				switch (responseData.rc) {
// 					case 1:
// //						Shark.appData.activityList = Shark.appData.activityList || [];

// 						activity.import(responseData.rows[0]);
// 						this.emit("created");

// 						Shark.get("activityList").unshift(Shark.get("newActivity"));
// 						this.emit("listChanged");
// 						break;
// 					case 7:
// 						this.emit("error", "error_missingData");
// 						break;
// 					case 9:
// 						this.emit("error", "error_default");
// 						break;
// 				}
// 			}
// 		}
// 	});
// });

// activityManager.addMethod("close", function (activity) {
// 	Shark.requestRemoteData({
// 		context: activityManager,
// 		data: {an: "close", activityId: activity.id, cx: "Activity", userGuid: Shark.get("currUser").id},
// 		complete: function (response) {
// 			if (response.isSuccess) {
// 				var responseData = response.data;

// 				switch (responseData.rc) {
// 					case 1:
// 						activity.import(responseData.rows[0]);
// 						this.emit("closed");

// //						Shark.get("activityList").unshift(Shark.get("newActivity"));
// 						this.emit("listChanged");
// 						break;
// 					case 7:
// 						this.emit("error", "error_missingData");
// 						break;
// 					case 9:
// 						this.emit("error", "error_default");
// 						break;
// 				}
// 			}
// 		}
// 	});
// });

// activityManager.addMethod("getList", function (projectId, getActiveActivities = false, getAllClosedActivities = false, getAllOpenActivities = false, getCreatedActivities = false) {
// 	//Object.assign({getAllOpenActivities: Shark.get("activeItems").showAllOpenActivities}, )
	
// 	if (Shark.get("activeItems").showActiveActivities !== undefined) {
// 		getActiveActivities = Shark.get("activeItems").showActiveActivities;
// 	}

// 	if (Shark.get("activeItems").showAllClosedActivities !== undefined) {
// 		getAllClosedActivities = Shark.get("activeItems").showAllClosedActivities;
// 	}

// 	if (Shark.get("activeItems").showAllOpenActivities !== undefined) {
// 		getAllOpenActivities = Shark.get("activeItems").showAllOpenActivities;
// 	}

// 	if (Shark.get("activeItems").showCreatedActivities !== undefined) {
// 		getCreatedActivities = Shark.get("activeItems").showCreatedActivities;
// 	}

// 	if (!getActiveActivities && !getAllClosedActivities && !getAllOpenActivities && !getCreatedActivities) {
// 		Shark.set("activityList", []);
// 		this.emit("listChanged");
// 		return;
// 	}
	
// 	Shark.requestRemoteData({
// 		context: activityManager,
// 		data: {an: "getList", getActiveActivities: getActiveActivities, getAllClosedActivities: getAllClosedActivities, getAllOpenActivities: getAllOpenActivities, getCreatedActivities: getCreatedActivities, projectId: projectId, cx: "Activity", userGuid: Shark.get("currUser").id},
// 		complete: function (response) {
// 			if (response.isSuccess) {
// 				var responseData = response.data;

// 				switch (responseData.rc) {
// 					case 1:
// 						Shark.set("activityList", responseData.rows.map(function (item) {
// 							return Shark.getModelInstance("Activity", item);
// 						}));
// 						this.emit("listChanged");

// 						break;
// 					case 7:
// 						this.emit("error", "error_missingData");
// 						break;
// 					case 9:
// 						this.emit("error", "error_default");
// 						break;
// 				}
// 			}
// 		}
// 	});
// });

// Shark.registerController(activityManager);

// export { activityManager };
